const ProfessionalsAll = () => import('@/views/Dashboard/ProfessionalsManagement/View/ProfessionalsAll');
const ProfessionalCreate = () => import('@/views/Dashboard/ProfessionalsManagement/Create/ProfessionalCreate');
const ProfessionalEdit = () => import('@/views/Dashboard/ProfessionalsManagement/Edit/ProfessionalEdit');
const ProfessionalDetails = () => import('@/views/Dashboard/MembersManagement/MembersManagementShowItem');

// Passthrough parent so nested children (list + create) render in its <router-view>.
const ProfessionalsLayout = { name: 'ProfessionalsLayout', render: (h) => h('router-view') };

export default {
  path: '/professionals-enabled',
  component: ProfessionalsLayout,
  children: [
    {
      path: '/',
      name: 'professionals-management',
      component: ProfessionalsAll,
      meta: { preserveTableState: true, resetPageStateOnLeave: true },
    },
    {
      path: 'create',
      name: 'professional-create',
      component: ProfessionalCreate,
      meta: { preservePageStateFor: 'professionals-management' },
    },
    {
      path: 'details/:id',
      name: 'professional-details',
      component: ProfessionalDetails,
      meta: {
        sidebarSection: 'professionals-management',
        preservePageStateFor: 'professionals-management',
        listRouteName: 'professionals-management',
      },
    },
    {
      path: 'edit/:id',
      name: 'professional-edit',
      component: ProfessionalEdit,
      meta: { preservePageStateFor: 'professionals-management' },
    },
  ],
};
